import { render, staticRenderFns } from "./MultipleChoiceExercisInfo.vue?vue&type=template&id=0139b49c"
import script from "./MultipleChoiceExercisInfo.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceExercisInfo.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceExercisInfo.vue?vue&type=style&index=0&id=0139b49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports